import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';

export const departmentsFiltersSchema = z
  .object({
    isHidden: z.boolean().catch(false),
    departments: z.array(z.string()).catch([]),
    companies: z.array(z.string()).catch([]),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
